<div class="w-100 d-flex justify-content-center align-items-center align-content-center" style="height: 100vh">
  <div class="text-center">
    <span>404</span>
    <p>Não encontramos essa página</p>
    <a class="botao-primario text-white texto-inter" href="https://pjus.com.br/">Ir para o site da PJUS</a>
  </div>

</div>
